<template>
<div class="chapter">
<div class="inner_page">
<p class="fm-right"><span><i>Have you heard</i></span></p>
<p class="fm-right1"><span><i>That silence where the birds are dead yet something</i></span></p>
<p class="fm-right1"><span><i>pipeth like a bird?</i></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// frantmatter01.vue?494c52ab